export default __webpack_public_path__ + "static/media/cards5.89d64abd.png";